import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "contentLoading"
}
const _hoisted_2 = {
  key: 1,
  class: "min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
}
const _hoisted_3 = { class: "max-w-md w-full space-y-8" }

import TopNavbar from '@/layout/components/topNavbar/TopNavbar.vue';
import ContentFooter from '@/layout/components/ContentFooter.vue';
import vLoaderAnimation from '@/components/template/v-loader-animation.vue';
import { useAuth } from '@/services/user/Auth0UserProvider';
import FlashMessage from '@/components/FlashMessage';
import { reactive, Ref, ref } from 'vue';
import { getAccessCheckerInstance } from '@/router/accessChecker';
import SidebarLinksCreator, { SidebarLink } from '@/router/sidebarLinksCreator';
import SideBar from '@/layout/components/sidebar/SideBar.vue';
import SideBarMobile from './components/sidebar/SideBarMobile.vue';
import Api from "@/services/api/ApiServiceFabrick";
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardLayout',
  setup(__props) {

const { isAuthenticated, loading } = useAuth();
const flashStatus = reactive({
  message: '',
  type: '',
  fadeout: true,
  show: false,
  manualLink: '',
});
const contentLoading = ref(false);
const isHamburgerOpen = ref(false);
const displaySidebar: Ref<SidebarLink[]> = ref([]);
const lowerDisplaySidebar: Ref<SidebarLink[]> = ref([
  {
    name: i18n.global.t('sideMenue.support'),
    path: process.env.VUE_APP_SUPPORT_LINK,
    icon: 'mdi-face-agent',
    extarnal_link: true,
    childLinks: [],
  },
]);

const getSideBarLinks = async () => {
  return new SidebarLinksCreator(
    await getAccessCheckerInstance(),
    await Api().getSelfOffice()
  ).getLinks;
};
(async () => {
  displaySidebar.value = await getSideBarLinks();
})();

const hideFlash = () => {
  flashStatus.show = false;
};
const showFlash = (message: string, type: string, fadeout: boolean, manualLink = '') => {
  moveToTop();
  flashStatus.message = message;
  flashStatus.type = type;
  flashStatus.fadeout = fadeout;
  flashStatus.show = true;
  flashStatus.manualLink = manualLink;
};
const moveToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};
const switchContentLoading = (bool: boolean) => {
  contentLoading.value = bool;
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!

  return (!_unref(loading) && _unref(isAuthenticated))
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(SideBarMobile, {
          sidebarLinks: displaySidebar.value,
          "lower-sidebar-links": lowerDisplaySidebar.value,
          isHamburgerOpen: isHamburgerOpen.value,
          "onUpdate:isHamburgerOpen": _cache[0] || (_cache[0] = ($event: any) => ((isHamburgerOpen).value = $event))
        }, null, 8, ["sidebarLinks", "lower-sidebar-links", "isHamburgerOpen"]),
        _createVNode(TopNavbar, {
          isHamburgerOpen: isHamburgerOpen.value,
          "onUpdate:isHamburgerOpen": _cache[1] || (_cache[1] = ($event: any) => ((isHamburgerOpen).value = $event))
        }, null, 8, ["isHamburgerOpen"]),
        _createVNode(SideBar, {
          sidebarLinks: displaySidebar.value,
          "lower-sidebar-links": lowerDisplaySidebar.value
        }, null, 8, ["sidebarLinks", "lower-sidebar-links"]),
        _createVNode(_unref(FlashMessage), {
          message: flashStatus.message,
          show: flashStatus.show,
          type: flashStatus.type,
          fadeOut: flashStatus.fadeout,
          manualLink: flashStatus.manualLink,
          onHide: hideFlash
        }, null, 8, ["message", "show", "type", "fadeOut", "manualLink"]),
        _createVNode(_component_v_main, null, {
          default: _withCtx(() => [
            (contentLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", null, "読み込み中")
                  ], -1)
                ]))]))
              : _createCommentVNode("", true),
            _createVNode(_component_router_view, {
              showFlash: showFlash,
              switchContentLoading: switchContentLoading
            })
          ]),
          _: 1
        }),
        _createVNode(ContentFooter)
      ], 64))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(vLoaderAnimation, {
            text: 'text-black',
            "loading-text-style": 'text-black text-lg'
          })
        ])
      ]))
}
}

})